/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren, useState } from 'react';
import { jsx, css } from '@emotion/react';
import DropdownMenu, { DropdownItemCheckbox, DropdownItemCheckboxGroup } from '@atlaskit/dropdown-menu';
import { FormattedMessage, useIntl } from 'components/i18n';
import { status as statusMessages, recurringSaleStatus} from '../messages';

type ValueType = (string | null)[] | null | undefined;

const defaultProps = {
  options: ['draft', 'unpaid', 'paid','partiallypaid'],
};

type Props = {
  value: ValueType
  onChange: (newValue: ValueType) => void;
} & typeof defaultProps;

const StatusFilter = (props:  PropsWithChildren<Props>) => {

  const intl = useIntl();
  const {value, onChange, options} = props;
  const status = value;

  const selectedItems = status || [];

  const handleSelection = (id: string) => () => {
    if (selectedItems.includes(id)) {
      onChange(selectedItems.filter(item => item !== id));
    } else {
      onChange([...selectedItems, id]);
    }
  };

  const selectedItemsNames = selectedItems.map((id: string|null) => intl.formatMessage(statusMessages[id!]||recurringSaleStatus[id!]).toLowerCase());
  let trigger = 'Status';
  if(selectedItemsNames.length>0) {
    trigger += `: ${ selectedItemsNames.join(', ')}`
  }

  return ( <DropdownMenu trigger={trigger} triggerType="button" triggerButtonProps={{spacing: "default"}}>
    <DropdownItemCheckboxGroup id="status">
        {options.map((id) => (
          <DropdownItemCheckbox
            id={id}
            key={id}
            isSelected={selectedItems.includes(id)}
            onClick={handleSelection(id)}
          >
              {/* @ts-ignore */}
              <FormattedMessage {...(statusMessages[id]||recurringSaleStatus[id])}/>
            </DropdownItemCheckbox>
        ))}
</DropdownItemCheckboxGroup>
</DropdownMenu>
  );
};

StatusFilter.defaultProps = defaultProps;

export default StatusFilter;
